import { navigation } from '@/app'
import { AppStatus, Session } from '@/redux'
import { analytics } from '@/services/analytics/segment'
import { queryClient } from '@/services/api/queryClient'
import { QueryKeys } from '@/services/api/session/queryKeys'
import { getFirebase } from '@/services/firebaseApp'
import { toggleOnboardingQuestionsVisibility } from '@/utils'

import { clearStorageKeys } from '@/features/Auth/session/clearStorageKeys'

export const logout = (withDone = true, isDelete = false) => {
  return new Promise<void>(async resolve => {
    if (withDone) {
      AppStatus.set('loading')
    }

    clearStorageKeys()

    const firebase = await getFirebase()

    setTimeout(() => {
      firebase.auth().signOut()
      queryClient.client.clear()
      AppStatus.clearModals()

      if (!isDelete) {
        analytics.track('log_out')
      }

      const userData = QueryKeys.me.getData()

      analytics.identify({ user: userData as never, isLoggedIn: false })

      setTimeout(() => {
        if (withDone) {
          AppStatus.set('done')
        }

        setTimeout(() => {
          analytics.reset()
          navigation.navigate('Home')
          resolve()
        })
      }, 1000)
    }, 2000)

    queryClient.client.setQueryData(QueryKeys.me.key(), null)
    Session.setHasLoggedOut(true)
    toggleOnboardingQuestionsVisibility()
  })
}
